<div class="flex flex-col min-[1400px]:flex-row gap-4 min-[1400px]:gap-0 overflow-auto relative w-full h-full rounded-lg">
  <div class="flex-1 left relative max-[1400px]:overflow-auto" [appLoading]="store.isLoading()">
    <app-challenge-list
      [challengeMasterDatas]="store.initialChallenges() || [] | sortAlphabet: 'Challenges'"
      [challengeName]="challengeName.Challenge"
      [challengeTitle]="challengeType.Challenge"
      (selectedChallengeChange)="handleChallengeSelection($event, challengeType.Challenge)"
    ></app-challenge-list>
  </div>
  <div class="flex-1 right relative flex flex-col bg-white">
    <div class="flex-auto">
      <app-challenge-list
        [subChallenges]="store.selectedSubChallenges() | sortAlphabet: 'Sub-Challenges'"
        [challengeName]="challengeName.SubChallenge"
        [challengeTitle]="challengeType.SubChallenge"
        (selectedSubChallengeChange)="handleChallengeSelection($event, challengeName.SubChallenge)"
      ></app-challenge-list>
    </div>
    <div class="add-btn">
      <p-button
        class="add-btn_label"
        label="Add To Selected Challenges"
        (onClick)="addPairChallenge()"
        [disabled]="!selectedChallenge()?.name || !selectedSubChallenge()?.name"
        [ngClass]="{ 'not-disable-btn': selectedChallenge()?.name && selectedSubChallenge()?.name }"
      />
    </div>
  </div>
</div>
